import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';
// initial state
const state = () => ({
  eventData: null,
  meetingName: '',
  moreInfoModalActive: false,
  entryClass: '',
  entryCondition: '',
  totalPrizeMoney: '',
  weather: '',
  raceType: '',
});

// actions
const actions = {
  // fetch harness event data by event id
  async fetchEventData(state, { eventId, meetingName }, fetcher = dataFetch) {
    try {
      const includeString = 'entry_conditions,prize_money,results,venue,weather,selections';
      const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${eventId}?include=${includeString}`;
      const res = await fetcher(eventEndpoint);
      // set meeting name
      state.commit('SET_MEETING_NAME', meetingName);
      // set event data
      const eventData = res.data.event;
      state.commit('SET_EVENT_DATA', { eventData });

      const { entry_conditions, prize_money, weather } = eventData;

      // set event entry class restriction
      const entryClass = entry_conditions.filter(event => {
        return event.type == 'raceClassRestriction';
      });

      if (entryClass.length > 0) {
        state.commit('SET_ENTRY_CLASS', entryClass[0].description);
      }

      // join entry conditions into one string
      const entryCondition = entry_conditions.map(e => e.description).join('. ');
      state.commit('SET_ENTRY_CONDITION', entryCondition);

      // get total prize money
      const prizeMoney = prize_money.map(prize => prize.value);
      state.commit('SET_TOTAL_PRIZE_MONEY', parseInt(prizeMoney.reduce((a, b) => a + b)));

      // set weather data
      state.commit('SET_WEATHER_DATA', weather);
    } catch (error) {
      console.log(error);
    }
  },
  // fetch harness event by slug and event number
  async fetchEventBySlug(state, { slug, eventNumber }, fetcher = dataFetch) {
    try {
      const meetingEndpoint = `${API_END_POINTS.HARNESS.MEETING}${slug}?include=events`;
      const res = await fetcher(meetingEndpoint);
      // set meeting
      const meetingData = res.data.meeting;
      state.commit('SET_MEETING_NAME', meetingData.name);

      const eventDataArray = meetingData.events.filter(event => {
        return event.event_number == eventNumber;
      });

      if (eventDataArray.length > 0) {
        const event = eventDataArray[0];

        try {
          const includeString = 'entry_conditions,prize_money,results,venue,weather,selections';
          const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${event.id}?include=${includeString}`;
          const res = await fetcher(eventEndpoint);

          // set event data
          const eventData = res.data.event;
          state.commit('SET_EVENT_DATA', { eventData });

          const { entry_conditions, prize_money, weather } = eventData;

          // set event entry class restriction
          const entryClass = entry_conditions.filter(event => {
            return event.type == 'raceClassRestriction';
          });

          if (entryClass.length > 0) {
            state.commit('SET_ENTRY_CLASS', entryClass[0].description);
          }

          // join entry conditions into one string
          const entryCondition = entry_conditions.map(e => e.description).join('. ');
          state.commit('SET_ENTRY_CONDITION', entryCondition);

          // get total prize money
          const prizeMoney = prize_money.map(prize => prize.value);
          state.commit('SET_TOTAL_PRIZE_MONEY', parseInt(prizeMoney.reduce((a, b) => a + b)));

          // set weather data
          state.commit('SET_WEATHER_DATA', weather);
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  },

  setMeetingName(state, meetingName) {
    state.commit('SET_MEETING_NAME', meetingName);
  },

  toggleMoreInfoModal(state) {
    state.commit('TOGGLE_MORE_INFO_MODAL');
  },

  setRaceType(state, type) {
    state.commit('SET_RACE_TYPE', type);
  },
};

// mutations
const mutations = {
  SET_EVENT_DATA: (state, { eventData }) => {
    state.eventData = eventData;
  },
  SET_MEETING_NAME: (state, meetingName) => {
    state.meetingName = meetingName;
  },
  TOGGLE_MORE_INFO_MODAL: state => {
    state.moreInfoModalActive = !state.moreInfoModalActive;
  },
  SET_TOTAL_PRIZE_MONEY: (state, total) => {
    state.totalPrizeMoney = total;
  },
  SET_ENTRY_CLASS: (state, entryClass) => {
    state.entryClass = entryClass;
  },
  SET_ENTRY_CONDITION: (state, entryCondition) => {
    state.entryCondition = entryCondition;
  },
  SET_WEATHER_DATA: (state, weather) => {
    state.weather = weather;
  },
  SET_RACE_TYPE: (state, type) => {
    state.raceType = type;
  },
};

// getter
const getters = {
  getEventData: state => {
    return state.eventData;
  },
  getVenue: state => {
    return state.eventData ? state.eventData.venue : {};
  },
  getEntryClass: state => {
    return state.entryClass;
  },
  getEntryCondition: state => {
    return state.entryCondition;
  },
  getTotalPrizeMoney: state => {
    return state.totalPrizeMoney;
  },
  getPrizeMoney: state => {
    return state.eventData ? state.eventData.prize_money : {};
  },

  getMeetingName: state => {
    return state.meetingName;
  },
  getWeather: state => {
    return state.weather;
  },
  isMoreInfoModalActive: state => {
    return state.moreInfoModalActive;
  },
  getRaceType: state => {
    return state.raceType;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
